import { Box, Modal } from "@mui/material";

const CitationsModal = ({ modalOpen, handleModalClose, citationURL }: any) => {

    const getFileExtension = (url: string): string => {
        if (!url) return "";
        try {
            // URL format: ...get_blob_content?code=...&file_name=FHA-1.docx&storage_account=...&container=content
            // Must read extension from file_name param, not from end of URL
            const urlObj = new URL(url);
            const fileName = urlObj.searchParams.get("file_name") || "";
            if (fileName) {
                const parts = fileName.split(".");
                return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
            }
        } catch {}
        // fallback: strip query params before splitting on dot
        const clean = url.split("?")[0];
        const parts = clean.split(".");
        return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
    };

    const OfficeViewer = ({ fileUrl }: any) => {
        // console.log(fileUrl, "fileUrl");
        const extension = getFileExtension(fileUrl);
        // console.log(extension, "extension");
        const officeUrl = ["pptx", "docx", "xlsx", "doc", "xls", "ppt", 'csv'].includes(
            extension
        )
            ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                fileUrl
            )}`
            : fileUrl;
        // console.log(extension, "extension");
        // console.log(officeUrl, "officeUrl");
        return (
            <iframe
                src={officeUrl}
                width="100%"
                height="99%"
                title="CitationsModal"
                allowFullScreen
                loading="lazy"
            ></iframe>
        );
    };
    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: "absolute" as "absolute",
                top: "5%",
                left: "5%",

                width: "90%",
                height: "90%",
                overflow: "auto",
                bgcolor: "background.paper",
                boxShadow: 10,
            }}>
                <OfficeViewer fileUrl={citationURL} />
                {/* <iframe src={`${citationURL}`}
                    title="Citation"
                    // sandbox="allow-scripts allow-same-origin"
                    style={{
                        width: "100%",
                        height: "100%"
                    }}></iframe> */}
            </Box>
        </Modal>)
}

export default CitationsModal;